import type { ReactNode } from 'react';

interface Props {
  children:   ReactNode;
  /** Largura mínima do conteúdo antes de rolar. Default: `min-w-[36rem]`. */
  minWidth?:  string;
  /** Rótulo da região rolável, lido por leitores de tela. */
  label?:     string;
  className?: string;
}

/**
 * Casca de rolagem horizontal para tabelas e grades largas.
 *
 * Sangra até a borda da página no mobile (`-mx-4 px-4`) para que a tabela use
 * a largura total da viewport em vez de ficar comprimida dentro do padding, e
 * volta ao fluxo normal a partir de `sm`. `tabIndex={0}` mantém a região
 * acessível por teclado quando o conteúdo realmente rola.
 */
export function TableScroll({ children, minWidth = 'min-w-[36rem]', label, className = '' }: Props) {
  return (
    <div
      tabIndex={0}
      role="region"
      aria-label={label}
      className={`-mx-4 overflow-x-auto px-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/20 sm:mx-0 sm:px-0 ${className}`}
    >
      <div className={minWidth}>{children}</div>
    </div>
  );
}
